class NavMenu {
	constructor() {
		this.wrapper = document.querySelector('.js-nav-menu');
		this.button = undefined;
		this.isOpen = false;

		if (this.wrapper) {
			this.initNavMenu();
		}
	}

	initNavMenu() {
		this.button = this.wrapper.querySelector('.js-nav-menu__button');

		this.button.addEventListener('click', this.toggleMenu.bind(this));
	}

	toggleMenu() {
		if (!this.isOpen) {
			this.wrapper.classList.add('is-active');
			this.button.setAttribute('aria-expanded', 'true');
			this.isOpen = true;
		} else {
			this.wrapper.classList.remove('is-active');
			this.button.removeAttribute('aria-expanded');
			this.isOpen = false;
		}
	}
}

export default NavMenu;
